import React from "react";
import { ArrowLeft } from "lucide-react";

export const MARKETING_SITE_URL = "https://realitycoach.ai";

/** Way back to the marketing site from the auth pages, which have no other navigation. */
const BackToHomeLink: React.FC = () => (
  <a href={MARKETING_SITE_URL} className="login-back-home">
    <ArrowLeft size={16} aria-hidden="true" />
    Back to home
  </a>
);

export default BackToHomeLink;
